import React, { useEffect, useState } from "react";
import CompanyContext from "./CompanyContext";
import axios from "axios";
import { COMPANY_URLS } from "../../../Utils/Company_App_Urls";

export default function CompanyContextProvider({ children }) {
  const [text, setTest] = useState("");
  const [loader, setLoader] = useState(false);
  const [activePlans, setActivePlans] = useState({
    condition: "",
  });
  const [CompanyProfileComaplete, setCompanyProfileComplete] = useState(false);
  const [toggleSideBar, setToggleSideBar] = useState(true);
  const [isCompanyProfileComplate, setIsCompanyProfileComplate] =
    useState(false);
  const [isJobCreated, setIsJobCreated] = useState(true);
  const [needTorender, setNeedTorender] = useState(false);
  const [profileLogo, setProfileLogo] = useState("");
  const [closeJobModalOpen, setCloseJobModalOpen] = useState({
    status: false,
    data: {},
  });
  const [appliedCandidateModalOpen, setAppliedCandidateModalOpen] =
    useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [appliedCandidateDetails, setAppliedCandidateDetails] = useState([]);
  const [previewData, setPreviewData] = useState({});
  const [showCandidateProfile, setShowCandidateProfile] = useState(false);

  const getCompanyDetails = () => {
    axios(COMPANY_URLS.companyDetail, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        setIsLogin(true);
        if (res?.data?.data?.profileComplete) {
          localStorage.setItem("isprofileComplete", "true");
        }
        setIsCompanyProfileComplate(res?.data?.data?.profileComplete);
      })
      .catch((err) => {
        setIsLogin(false);
      });
  };

  const getCompanyProfileDetails = () => {
    console.log("token", localStorage.getItem("userToken"));
    axios
      .get(`${COMPANY_URLS.get_profile}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        setProfileLogo(res?.data?.data?.companylogo);
      })
      .catch((err) => {});
  };

  const fetchActivePlan = async () => {
    try {
      const response = await axios.get(COMPANY_URLS.getActivePlan, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/json",
        },
      });

      console.log("Full API response:", response);
      console.log("Response data structure:", response.data);

      if (response.data && response.data.data) {
        const planData = response?.data?.data;
        console.log("Plan data:", planData);

        setActivePlans({
          planName: planData.planName || "",
          activatedSince: planData.activatedSince || "",
          amount: planData.amount || "",
          duration: planData.duration || "",
          expiredAt: planData.expiredAt || "",
          condition: planData.condition || "",
        });
      } else {
        console.log("No active plan data found in response");
      }
    } catch (err) {
      console.error("Error fetching active plan:", err);
    }
  };

  useEffect(() => {
    getCompanyDetails();
    getCompanyProfileDetails();
    fetchActivePlan();
    setIsCompanyProfileComplate(
      localStorage.getItem("isprofileComplete") === "true"
    );
  }, []);

  return (
    <CompanyContext.Provider
      value={{
        activePlans,
        setActivePlans,
        text,
        setTest,
        loader,
        setLoader,
        CompanyProfileComaplete,
        setCompanyProfileComplete,
        toggleSideBar,
        setToggleSideBar,
        isCompanyProfileComplate,
        setIsCompanyProfileComplate,
        isJobCreated,
        setIsJobCreated,
        getCompanyDetails,
        needTorender,
        setNeedTorender,
        closeJobModalOpen,
        setCloseJobModalOpen,
        profileLogo,
        setProfileLogo,
        appliedCandidateModalOpen,
        setAppliedCandidateModalOpen,
        appliedCandidateDetails,
        setAppliedCandidateDetails,
        isLogin,
        previewData,
        setPreviewData,
        showCandidateProfile,
        setShowCandidateProfile,
        getCompanyProfileDetails,
      }}
    >
      {children}
    </CompanyContext.Provider>
  );
}
